import React from "react";
import styled from "styled-components";
import Speaker from "./Speaker";
const Speakers = ({ speakers }) => {
  return (
    <CardDeck>
      {speakers.map((speaker, index) => (
        <Speaker key={index} data={speaker} speakers={speakers} />
      ))}
    </CardDeck>
  );
};

const CardDeck = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-row-gap: 1.5rem;
  grid-template-columns: 1fr;
  margin: 0 auto;
  position: relative;
  width: 90vw;
  max-width: 1200px;
  @media (min-width: 768px) {
    grid-column-gap: 2rem;
    grid-row-gap: 3rem;
    grid-template-columns: repeat(8, 1fr);
    justify-content: center;
    padding: 0 1rem;
    width: 95vw;
    div {
      grid-column: span 4;
    }
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(6, 1fr);
    justify-content: center;
    padding: 0 3rem;
    width: ${({ wider }) => (wider ? '70vw' : '100vw')};
    div {
      grid-column: ${({ wider }) => (wider ? 'span 3' : 'span 2')};
      &:nth-child(n+4) {
        grid-column: span 3;
      }


      &:nth-child(n+6) {
        grid-column: span 2;
      }

      /* &:nth-last-child(2):nth-child(3n + 1) {
        grid-column-end: 5;
      }

      &:last-child:nth-child(3n - 2) {
        grid-column-end: ${({ wider }) => (wider ? 'unset' : '5')};
      } */
    }
  }
`;

export default Speakers;    